import script from "./InputHelper.vue?vue&type=script&lang=ts&setup=true"
export * from "./InputHelper.vue?vue&type=script&lang=ts&setup=true"

import "./InputHelper.vue?vue&type=style&index=0&id=1bb3e9bd&scoped=true&lang=scss"

import exportComponent from "/root/talkmateai-admin/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bb3e9bd"]])

export default __exports__